module.exports = __webpack_public_path__ + "static/img/constructBanner.e3fa348c.png";